import { render, staticRenderFns } from "./ValueUnit.vue?vue&type=template&id=16d115b8&"
import script from "./ValueUnit.vue?vue&type=script&lang=js&"
export * from "./ValueUnit.vue?vue&type=script&lang=js&"
import style0 from "./ValueUnit.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports